var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendApproval(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#415385"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.08 15.5037L16.576 9.98374C16.48 9.88774 16.432 9.77041 16.432 9.63174C16.432 9.49308 16.48 9.37574 16.576 9.27974C16.672 9.18374 16.7893 9.13574 16.928 9.13574C17.0667 9.13574 17.184 9.18374 17.28 9.27974L24 15.9997L17.28 22.7197C17.184 22.8157 17.0667 22.8637 16.928 22.8637C16.7893 22.8637 16.672 22.8157 16.576 22.7197C16.48 22.6237 16.432 22.5064 16.432 22.3677C16.432 22.2291 16.48 22.1117 16.576 22.0157L22.08 16.4957H8.496C8.35733 16.4957 8.24 16.4477 8.144 16.3517C8.048 16.2557 8 16.1384 8 15.9997C8 15.8611 8.048 15.7437 8.144 15.6477C8.24 15.5517 8.35733 15.5037 8.496 15.5037H22.08Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendApproval);
export default __webpack_public_path__ + "static/media/sendApproval.c9f91cd8dbc5d800e03ca22ca4c1a69c.svg";
export { ForwardRef as ReactComponent };